orders-info-expandable
  .expandable-wrap(class="{expanded: expanded}")
    orders-info(tag-scope="{this.tagScope}")
  .expandable-over(class="{expanded: expanded}")
  .expandable-btn-wrap(class="{expanded: expanded}")
    span.btn.waves-effect.waves-light.btn-success.btn-outline-success(onClick="{onClickExpandableBtn}")
      i.feather.icon-chevrons-down
  script(type="typescript").
    this.mixin('shared.expandable');
  style(scoped).
    :scope {
      display: block;
      position: relative;
    }
    .expandable-wrap {
      max-height: 200px;
    }
